import type {StackProps} from '@mui/material/Stack';
import type {SvgIconProps} from '@mui/material/SvgIcon';
import type {ReactElement, ReactNode} from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {mergeSlotProps} from '@mui/material/utils';
import React from 'react';

interface EmptyMessageProps {
  title?: string;
  icon?: SvgIconProps;
  children?: ReactNode;
  rootProps?: StackProps;
}

const EmptyMessage = ({
  title,
  icon: iconProp,
  children,
  rootProps = {},
}: EmptyMessageProps) => {
  const icon = iconProp
    ? React.cloneElement(iconProp as ReactElement<SvgIconProps>, {
        sx: {
          fontSize: 48,
        },
      })
    : null;

  return (
    <Stack
      {...mergeSlotProps<StackProps>(rootProps, {
        sx: {
          color: 'text.secondary',
          flexShrink: 0,
          gap: 1,
          margin: 'auto',
          padding: 4,
          textAlign: 'center',
          alignItems: 'center',
        },
      })}
    >
      {icon}

      {title && (
        <Typography
          gutterBottom
          variant="h6"
          sx={{color: 'text.secondary', fontWeight: '500', textWrap: 'balance'}}
        >
          {title}
        </Typography>
      )}

      {children}
    </Stack>
  );
};

export default EmptyMessage;
